<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="countryCharCode" label="国家中文名" :rules="[{ required: true, message: '请选择' }]">
        <CosApiSelect
          :api="getCountry"
          :allowClear="false"
          show-search
          optionFilterProp="label"
          v-model:value="editForm.countryCharCode"
          :fieldNames="{ label: 'countryCnName', value: 'countryCharCode' }"
          @change="handleChangeSelect"
        ></CosApiSelect>
      </a-form-item>
      <a-form-item name="provinceName" label="省 / 州:" :rules="[{ required: true, message: '请选择' }]">
        <CosApiSelect
          :api="getProvince"
          :params="countryData"
          show-search
          optionFilterProp="label"
          v-model:value="editForm.provinceName"
          :allowClear="false"
          :fieldNames="{ label: 'provinceName', value: 'provinceName' }"
          :immediate="false"
          @change="handleChangeProvinceSelect"
        ></CosApiSelect>
      </a-form-item>
      <a-form-item name="cityName" label="城市" :rules="[{ required: true, message: '请选择' }]">
        <CosApiSelect
          :api="getCity"
          :params="provinceData"
          show-search
          optionFilterProp="label"
          :allowClear="false"
          v-model:value="editForm.cityName"
          :fieldNames="{ label: 'cityName', value: 'cityName' }"
          :immediate="false"
        ></CosApiSelect>
      </a-form-item>
      <a-form-item name="areaName" label="县区" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.areaName" placeholder="请输入" v-trim />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, computed } from 'vue'
import { adminAreaSave, adminAreaUpdate, adminAreaListByParentId } from '@/api/overseasSales/administrativeRegion'
import type { FormInstance } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import { adminAreaSaveParams } from '@/typings/api/overseasSales'

export default { name: 'editModalProvince' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<adminAreaSaveParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: adminAreaSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    console.log('editForm.value: ', editForm.value)
  } else {
    editForm.value = {}
  }
}
const conuntryArr = ref<adminAreaSaveParams[]>([])
const provinceArr = ref<adminAreaSaveParams[]>([])
// const countryData = ref()
// const provinceData = ref()
const countryData = computed(() => {
  const obj = conuntryArr.value.find(
    (item: adminAreaSaveParams) => item.countryCharCode === editForm.value.countryCharCode
  )
  // 清空省、城市的请求参数
  return { parentId: obj?.id, level: 2 }
})
const provinceData = computed(() => {
  if (!countryData.value.parentId) {
    return { parentId: '', level: 3 }
  }
  const obj = provinceArr.value.find((item: adminAreaSaveParams) => item.provinceName === editForm.value.provinceName)
  return { parentId: obj?.id, level: 3 }
})
const getCountry = async () => {
  try {
    const res: any = await adminAreaListByParentId({ parentId: '-1', level: 1 })
    conuntryArr.value = res.data
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}
const handleChangeSelect = () => {
  editForm.value.provinceName = undefined
  editForm.value.cityName = undefined
  editForm.value.areaName = undefined
}

const getProvince = async () => {
  if (!countryData.value || !countryData.value.parentId) {
    return []
  }
  try {
    const res: any = await adminAreaListByParentId(countryData.value)
    provinceArr.value = res.data
    return res.data
  } catch (error) {}
}
const handleChangeProvinceSelect = () => {
  editForm.value.cityName = undefined
  editForm.value.areaName = undefined
}
const cityArr = ref<adminAreaSaveParams[]>([])

const getCity = async () => {
  if (!provinceData.value || !provinceData.value.parentId) {
    return []
  }
  try {
    const res: any = await adminAreaListByParentId(provinceData.value)
    cityArr.value = res.data
    return res.data
  } catch (error) {}
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = editForm.value
    try {
      const index = conuntryArr.value.findIndex(
        (item: adminAreaSaveParams) => item.countryCharCode === editForm.value.countryCharCode
      )
      const indexCity = cityArr.value.findIndex(
        (item: adminAreaSaveParams) => item.cityName === editForm.value.cityName
      )
      if (editForm.value.id) {
        await adminAreaUpdate({
          ...p,
          id: editForm.value.id,
          level: 4,
          name: editForm.value.areaName,
          fullName: `${conuntryArr.value[index].countryCnName}/${editForm.value.provinceName}/${editForm.value.cityName}/${editForm.value.areaName}`
        })
      } else {
        await adminAreaSave({
          ...p,
          level: 4,
          name: editForm.value.areaName,
          provinceName: editForm.value.provinceName,
          cityName: editForm.value.cityName,
          fullName: `${conuntryArr.value[index].countryCnName}/${editForm.value.provinceName}/${editForm.value.cityName}/${editForm.value.areaName}`,
          countryCnName: conuntryArr.value[index].countryCnName,
          countryEnName: conuntryArr.value[index].countryEnName,
          parentId: cityArr.value[indexCity].id
        })
      }
      toggle()
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      console.log('error: ', error)
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
